/* eslint-disable no-restricted-imports */
/* eslint-disable react/forbid-elements */
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import classnames from 'classnames'
import bootstrappedData from 'base/lib/singletons/bootstrapped_data'
import PropTypes from 'prop-types'
import { isInternal } from 'base/lib/route_to'
import FoundationLink from '@everlane/link'

function ReactRouterLink({ path, className, replace, ...props }) {
  const location = useLocation()
  const classes = classnames(
    {
      'no-underline': !path,
    },
    className,
  )

  // This is a temporary measure for a fix React Router is working on: https://github.com/ReactTraining/react-router/issues/5362
  // and also a placeholder until we can remove all RouterLinks with blank hrefs
  const shouldReplace = replace || path === location.pathname || !path

  return <Link className={classes} replace={shouldReplace} to={path || ''} {...props} />
}

function RouterLink({ className, href, to, ...props }) {
  const path = to || href

  if (bootstrappedData.isOnReactRouter && isInternal(path)) {
    return <ReactRouterLink className={className} path={path} {...props} />
  } else {
    return <a className={className} href={path} {...props} />
  }
}

export const EverlaneLink = props => {
  return <FoundationLink as={RouterLink} {...props} />
}

RouterLink.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
}

export default RouterLink
